export default __webpack_public_path__ + "static/tanmai-talk-e720c139b3dd0e1cd36077d6eb36bb44.png";